import { makeVar } from "shared/providers/apollo/apollo.package";

/**
 * Global flag that indicates if user is changing property
 */
export const propertySwitchingVar = makeVar(false);

export const resetPropertySwitchingVar = () => propertySwitchingVar(false);
